import React, { useState, useEffect } from "react";
import { logApi } from "../../api/Api";

const   SolarGrid1 = ({ svgColor }) => {
    const [logData, setLogData] = useState(null); // Initialize as null or an object
    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });

    const fetchLogData = async () => {
        try {
            const res = await logApi(credentials);
            if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
                // Assuming you need the first object in the array
                setLogData(res.TOT_LIVE_KW_NEW[0]);
            } else {
                setLogData(null); // Handle no data scenario
            }
        } catch (error) {
            console.error("Error fetching log data:", error);
            setLogData(null); // Handle error scenario
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials]);



    // Determine the color for the SOLAR value
    const solarColor =
        logData?.SOLAR == null
            ? "gray" // No data
            : logData.SOLAR <= 0
                ? "red" // Solar < 1
                : "green"; // Solar >= 1

    // Determine the color for the LOAD value
    const loadColor =
        logData?.TOTAL_LOAD == null
            ? "gray" // No data
            : logData.TOTAL_LOAD <= 0
                ? "red" // Solar < 1
                : "green"; // Solar >= 1


    // Determine the color for the DG value
    const dgColor =
        logData?.GenSet == null
            ? "gray" // No data
            : logData.GenSet <= 0
                ? "red" // Solar <= 0
                : "green"; // Solar > 0





    return (
        <>

            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="100%" height="400px" viewBox="0 0 389.000000 389.000000"
                preserveAspectRatio="xMidYMid meet">

                <g transform="translate(-650.000000,1520.000000) scale(0.100000,-0.100000)"
                    fill="#000000" stroke={svgColor}>
                    <path d="M6260 14011 c0 -17 5 -31 10 -31 6 0 10 11 10 24 0 14 -4 28 -10 31
-6 4 -10 -7 -10 -24z" fill={solarColor} />
                    <path d="M10461 14001 c-6 -10 -27 -66 -47 -123 -36 -102 -37 -104 -140 -208
-111 -115 -151 -180 -109 -180 8 0 15 5 15 10 0 20 31 23 44 5 14 -19 36 -13
36 11 0 9 11 14 36 14 58 0 36 25 -26 28 l-53 3 69 70 c37 38 72 69 76 69 5 0
8 -41 8 -92 l0 -91 -100 -103 c-109 -112 -146 -174 -105 -174 8 0 15 6 15 14
0 27 23 30 43 5 l19 -24 15 23 c10 14 25 22 44 22 31 0 39 14 13 24 -9 3 -34
6 -57 6 l-41 0 69 70 c38 39 73 70 77 70 5 0 8 -44 8 -97 0 -96 -1 -99 -67
-270 l-68 -172 -115 -2 c-98 -2 -107 -3 -60 -9 30 -5 233 -8 450 -8 217 0 420
3 450 8 47 6 38 7 -60 9 l-115 1 -67 170 c-68 170 -68 171 -68 270 0 55 3 100
8 100 4 0 39 -31 77 -70 l69 -70 -41 0 c-23 0 -48 -3 -57 -6 -26 -10 -18 -24
14 -24 19 0 33 -7 40 -20 12 -23 30 -27 30 -6 0 26 23 30 41 7 10 -13 23 -21
28 -19 22 8 -22 77 -111 173 l-98 104 0 90 c0 50 4 91 8 91 13 0 132 -124 132
-138 0 -8 -17 -12 -50 -12 -58 0 -67 -15 -15 -24 21 -4 35 -13 35 -21 0 -8 7
-15 15 -15 8 0 15 5 15 10 0 20 31 23 45 4 10 -14 17 -16 25 -8 20 20 -7 60
-112 169 l-103 106 -45 122 -45 122 -42 3 c-33 2 -44 -1 -52 -17z m110 -116
c26 -71 34 -102 25 -107 -16 -11 -174 -10 -180 1 -7 10 50 179 67 199 5 7 19
12 30 10 15 -2 29 -26 58 -103z m3 -153 c3 -5 -10 -24 -30 -43 l-34 -33 -43
42 -42 42 72 0 c40 0 74 -4 77 -8z m-124 -67 l34 -35 -42 -43 -42 -42 0 78 c0
42 4 77 8 77 4 0 23 -16 42 -35z m170 -55 l0 -65 -42 42 -42 43 34 35 c42 43
50 34 50 -55z m-73 -42 c18 -18 33 -36 33 -40 0 -4 -35 -8 -77 -8 l-77 0 39
40 c21 22 41 40 44 40 3 0 20 -14 38 -32z m27 -85 c7 -8 -53 -73 -68 -73 -12
0 -76 61 -76 72 0 10 134 11 144 1z m-116 -77 c31 -27 28 -40 -18 -76 l-40
-32 0 77 c0 85 -2 84 58 31z m162 -43 c0 -35 -3 -63 -7 -63 -11 0 -73 63 -73
74 0 6 14 25 32 43 39 41 48 31 48 -54z m-64 -55 c24 -23 44 -46 44 -53 0 -6
-22 -32 -48 -58 l-48 -47 -49 50 -49 50 49 50 c27 28 51 50 53 50 2 0 23 -19
48 -42z m-120 -139 l43 -42 -82 -89 c-45 -49 -92 -95 -104 -103 l-22 -15 18
53 c32 92 93 237 99 237 4 0 25 -19 48 -41z m251 -95 c29 -71 53 -136 53 -144
0 -8 -45 30 -100 85 -55 55 -100 104 -100 109 0 15 73 87 84 83 6 -2 34 -62
63 -133z m-124 -31 c27 -25 67 -66 89 -90 l41 -43 -189 0 -189 1 93 89 c52 50
96 90 99 90 3 0 28 -21 56 -47z"
                        fill={
                            logData?.GRID == null
                                ? "gray" // No data
                                : logData.GRID <= 0
                                    ? "red" // Grid < 1
                                    : "green" // Grid > 0
                        }
                    />
                    <path d="M6140 13998 c0 -9 9 -26 20 -39 19 -23 19 -23 20 -3 0 11 -9 29 -20
39 -17 15 -20 16 -20 3z" fill={solarColor} />
                    <path d="M6372 13988 c-15 -15 -16 -38 -2 -38 12 0 23 25 18 40 -2 7 -7 7 -16
-2z" fill={solarColor} />
                    <path d="M6215 13916 c-16 -7 -41 -26 -55 -41 -21 -23 -25 -36 -25 -92 0 -62
1 -66 40 -101 l39 -36 16 54 c26 88 36 100 78 101 20 0 54 3 75 7 l37 7 -18
35 c-20 38 -89 80 -132 80 -14 -1 -38 -7 -55 -14z" fill={solarColor} />
                    <path d="M6050 13910 c0 -11 33 -30 51 -30 8 0 5 7 -6 20 -19 21 -45 27 -45
10z" fill={solarColor} />
                    <path d="M6460 13913 c-24 -9 -40 -25 -35 -34 8 -12 55 12 55 28 0 7 -1 13 -2
12 -2 0 -10 -3 -18 -6z" fill={solarColor} />
                    <path d="M6033 13786 c10 -8 27 -11 38 -9 27 7 5 23 -31 23 -23 -1 -24 -2 -7
-14z" fill={solarColor} />
                    <path d="M6272 13738 c-6 -18 -13 -41 -17 -50 -6 -16 0 -18 54 -18 65 0 67 1
74 70 2 23 -1 25 -50 28 -51 3 -52 2 -61 -30z" fill={solarColor} />
                    <path d="M6412 13730 c-13 -52 -1 -61 66 -53 49 5 52 8 52 34 0 15 3 34 6 43
5 14 -3 16 -54 16 l-60 0 -10 -40z" fill={solarColor} />
                    <path d="M6566 13754 c-3 -9 -6 -31 -6 -50 l0 -34 75 0 75 0 0 50 0 50 -69 0
c-54 0 -70 -4 -75 -16z" fill={solarColor} />
                    <path d="M6740 13719 l0 -51 60 4 c33 2 62 6 65 9 2 3 0 21 -5 41 -9 31 -15
36 -48 42 -71 11 -72 11 -72 -45z" fill={solarColor} />
                    <path d="M6880 13758 c0 -7 5 -30 11 -52 l11 -38 51 6 c28 4 54 9 56 12 2 2
-1 22 -8 44 l-12 40 -54 0 c-37 0 -55 -4 -55 -12z" fill={solarColor} />
                    <path d="M6065 13680 c-11 -13 -14 -20 -6 -20 18 0 51 19 51 30 0 17 -26 11
-45 -10z" fill={solarColor} />
                    <path d="M6240 13643 c0 -5 -7 -30 -15 -57 l-15 -49 63 7 c34 4 65 10 69 14 4
4 11 26 16 50 l10 42 -64 0 c-35 0 -64 -3 -64 -7z" fill={solarColor} />
                    <path d="M6556 13628 c-3 -13 -6 -38 -6 -56 l0 -33 83 3 82 3 3 53 3 52 -79 0
c-74 0 -80 -2 -86 -22z" fill={solarColor} />
                    <path d="M6740 13610 c0 -56 11 -64 89 -68 l70 -4 -11 38 c-15 56 -23 62 -89
66 l-59 3 0 -35z" fill={solarColor} />
                    <path d="M8645 13641 c-89 -23 -186 -100 -235 -186 -41 -71 -58 -176 -42 -252
26 -127 95 -218 204 -275 58 -30 71 -32 158 -33 86 0 101 3 161 31 81 38 140
98 182 184 29 59 32 73 32 160 0 86 -3 101 -32 162 -37 79 -90 133 -174 178
-52 27 -74 33 -143 36 -44 2 -94 0 -111 -5z m178 -36 c104 -27 177 -90 226
-195 22 -46 26 -69 26 -140 0 -76 -4 -93 -33 -152 -56 -113 -159 -186 -279
-196 -136 -11 -270 66 -332 190 -28 56 -31 70 -31 157 0 80 4 105 24 147 30
65 77 118 133 151 95 55 163 65 266 38z" fill={svgColor} />
                    <path d="M6385 13599 c-4 -22 -5 -42 -3 -43 1 -2 31 -6 66 -9 68 -7 66 -9 77
56 l6 37 -70 0 -69 0 -7 -41z" fill={solarColor} />
                    <path d="M6914 13590 l10 -50 63 0 c69 0 70 1 52 63 l-10 37 -63 0 -63 0 11
-50z" fill={solarColor} />
                    <path d="M6157 13612 c-19 -20 -23 -42 -7 -42 12 0 32 38 28 51 -2 6 -11 2
-21 -9z" fill={solarColor} />
                    <path d="M6398 13513 c-22 -3 -30 -12 -38 -41 -19 -72 -19 -72 70 -72 l80 0 0
55 c0 40 -4 55 -14 55 -7 0 -26 2 -42 4 -16 2 -41 2 -56 -1z" fill={solarColor} />
                    <path d="M6186 13463 c-9 -26 -16 -50 -16 -55 0 -4 33 -8 74 -8 l73 0 7 39 c3
22 9 46 12 55 5 14 -4 16 -64 16 l-70 0 -16 -47z" fill={solarColor} />
                    <path d="M6540 13455 l0 -55 95 0 95 0 0 39 c0 70 -2 71 -101 71 l-89 0 0 -55z" fill={solarColor} />
                    <path d="M6763 13502 c-7 -4 -9 -24 -6 -55 l6 -47 83 0 c62 0 82 3 79 13 -2 6
-9 31 -15 55 l-11 42 -62 0 c-34 0 -67 -4 -74 -8z" fill={solarColor} />
                    <path d="M6944 13504 c-7 -3 -7 -19 0 -54 l10 -50 73 0 c53 0 71 3 68 13 -2 6
-9 31 -15 55 l-11 42 -57 -1 c-31 0 -62 -3 -68 -5z" fill={solarColor} />
                    <path d="M6164 13362 c-7 -4 -21 -37 -32 -74 l-20 -68 82 0 81 0 16 70 c9 38
13 72 11 75 -8 8 -126 6 -138 -3z" fill={solarColor} />
                    <path d="M6344 13362 c-9 -6 -34 -105 -34 -134 0 -4 43 -8 95 -8 l95 0 0 53
c0 28 3 62 6 75 6 21 4 22 -72 22 -44 0 -84 -4 -90 -8z" fill={solarColor} />
                    <path d="M6530 13318 c0 -29 -3 -63 -6 -75 -6 -23 -6 -23 105 -23 l111 0 0 53
c0 99 2 97 -111 97 l-99 0 0 -52z" fill={solarColor} />
                    <path d="M6765 13303 c4 -38 9 -71 12 -75 2 -5 44 -8 94 -8 49 0 89 3 89 8 0
6 -11 56 -25 120 -5 21 -10 22 -91 22 l-86 0 7 -67z" fill={solarColor} />
                    <path d="M6960 13365 c0 -3 7 -37 16 -76 l16 -69 83 0 83 0 -23 73 -23 72 -76
3 c-42 2 -76 0 -76 -3z" fill={solarColor} />
                    <path d="M8035 13275 l27 -45 -26 -46 c-15 -26 -25 -48 -23 -50 3 -4 196 82
205 91 6 5 -181 95 -198 95 -6 0 1 -20 15 -45z" fill={svgColor} />
                    <path d="M7525 13230 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z" fill={svgColor} />
                    <path d="M7642 13230 c10 -6 25 -7 40 -1 20 9 18 10 -17 10 -31 0 -36 -2 -23
-9z" fill={svgColor} />
                    <path d="M7793 13229 c11 -7 23 -7 35 0 14 9 11 10 -18 10 -29 0 -32 -1 -17
-10z" fill={svgColor} />
                    <path d="M7944 13229 c12 -8 25 -8 40 -1 18 9 16 11 -19 11 -33 0 -37 -1 -21
-10z" fill={svgColor} />
                    <path d="M9220 13230 c0 -13 18 -22 24 -11 3 5 -1 11 -9 15 -8 3 -15 1 -15 -4z" fill={svgColor} />
                    <path d="M9342 13220 c10 -6 25 -7 40 -1 20 9 18 10 -17 10 -31 0 -36 -2 -23
-9z" fill={svgColor} />
                    <path d="M9493 13219 c11 -7 23 -7 35 0 14 9 11 10 -18 10 -29 0 -32 -1 -17
-10z" fill={svgColor} />
                    <path d="M9644 13219 c12 -8 25 -8 40 -1 18 9 16 11 -19 11 -33 0 -37 -1 -21
-10z" fill={svgColor} />
                    <path d="M6610 13110 c0 -79 0 -80 25 -80 25 0 25 1 25 80 0 79 0 80 -25 80
-25 0 -25 -1 -25 -80z" fill={solarColor} />
                    <path d="M6320 12960 l-75 -39 390 0 390 0 -75 39 -75 39 -240 0 -240 0 -75
-39z" fill={solarColor} />
                </g>
            </svg>


        </>
    );
};

export default SolarGrid1;